(function () {
  'use strict';

  /*
    ArcaVerse add-on property cleanup

    Purpose:
    Shopify checkout shows visible line item properties.
    Paid add-on variants already explain the add-on type, so we clean the descriptive
    property labels before /cart/add.js receives the request.

    Before:
      Custom Text
      Applies To: Ultra-Slim Deck Box
      Custom Text: Counter Deck

    After:
      Custom Text
      Text: Counter Deck

    Before:
      Stock Icon
      Applies To: Ultra-Slim Deck Box
      Icon Request: Blue and White Land Icons

    After:
      Stock Icon
      Icon: Blue and White Land Icons
  */

  if (window.__arcaverseAddonPropertyCleanupLoaded) return;
  window.__arcaverseAddonPropertyCleanupLoaded = true;

  function isCartAddEndpoint(url) {
    return String(url || '').indexOf('/cart/add') !== -1;
  }

  function getUrl(input) {
    if (!input) return '';

    if (typeof input === 'string') return input;

    if (input.url) return input.url;

    return String(input);
  }

  function moveProperty(props, oldName, newName) {
    if (!props || props[oldName] == null || props[oldName] === '') return;

    if (props[newName] == null || props[newName] === '') {
      props[newName] = props[oldName];
    }

    delete props[oldName];
  }

  function hideProperty(props, oldName, newName) {
    if (!props || props[oldName] == null || props[oldName] === '') return;

    if (props[newName] == null || props[newName] === '') {
      props[newName] = props[oldName];
    }

    delete props[oldName];
  }

  function cleanAddonProperties(props) {
    if (!props || typeof props !== 'object') return props;

    var addonKey = props._av_addon_key;

    if (!addonKey) return props;

    hideProperty(props, 'Applies To', '_av_applies_to');

    if (addonKey === 'custom_text' && !props['Text Location'] && !props._av_text_slot && !props._av_renderer_slot) {
      moveProperty(props, 'Custom Text', 'Text');
      moveProperty(props, 'Customization Request', 'Text');
    }

    if (addonKey === 'stock_icon' && !props['Icon Location'] && !props._av_icon_slot && !props._av_renderer_slot) {
      moveProperty(props, 'Icon Request', 'Icon');
      moveProperty(props, 'Customization Request', 'Icon');
    }

    if (addonKey === 'extra_color' && !props._av_color_zone) {
      moveProperty(props, 'Lid Color Request', 'Color');
      moveProperty(props, 'Lid Color', 'Color');
      moveProperty(props, 'Customization Request', 'Color');
    }

    if (addonKey === 'custom_image_upload') {
      moveProperty(props, 'Custom Image Upload', 'Image');
      moveProperty(props, 'Image Upload', 'Image');
      moveProperty(props, 'Customization Request', 'Image');
    }

    if (addonKey === 'pattern') {
      moveProperty(props, 'Pattern Request', 'Pattern');
      moveProperty(props, 'Customization Request', 'Pattern');
    }

    return props;
  }

  function cleanCartPayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;

    if (Array.isArray(payload.items)) {
      payload.items.forEach(function (item) {
        if (item && item.properties) {
          item.properties = cleanAddonProperties(item.properties);
        }
      });
    } else if (payload.properties) {
      payload.properties = cleanAddonProperties(payload.properties);
    }

    return payload;
  }

  function tryCleanBody(body) {
    if (!body || typeof body !== 'string') return body;

    try {
      var payload = JSON.parse(body);
      payload = cleanCartPayload(payload);
      return JSON.stringify(payload);
    } catch (error) {
      return body;
    }
  }

  if (window.fetch && !window.__arcaverseAddonPropertyCleanupFetchPatched) {
    window.__arcaverseAddonPropertyCleanupFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = getUrl(input);

      if (isCartAddEndpoint(url) && init && init.body) {
        init = Object.assign({}, init);
        init.body = tryCleanBody(init.body);
      }

      return originalFetch.call(this, input, init);
    };
  }
})();